const Main = () => {
  return (
    <div className="maincontainer">
      <img
        id="profileimage"
        src="/Headshot.jpg"
        alt="placeholder profile shot"
      />
      <div id="paragraphdiv">
        <p className="content_text">Hello, and welcome to my website.</p>
        <p className="content_text">
          I am an RICS Chartered Commercial Property Surveyor and Registered Valuer based in Manchester, UK and operating across all of England, Wales, Scotland and Northern Ireland.
        </p>
        <p className="content_text">
         I have extensive experience in undertaking commercial real estate valuations across a variety of asset classes including - but not limited to - industrial, retail, offices, residential and development land. My clients have included banks, REITs, publicly traded companies, private companies, high net worth individuals and public sector bodies, amongst others. My work has encompassed valuation purposes such as loan security, company accounts, purchase and sale reports, tax and probate reviews as well as repeat monthly and quarterly fund valuations.
        </p>
        <p className="content_text">
          I qualified as an MRICS Chartered Commercial Property Surveyor and Registered Valuer in July 2022 after commencing work in the Cushman & Wakefield valuation team in November 2021. I was promoted to Senior Surveyor in July 2024. In 2025 I was shortlisted for both RICS Matrics Commercial Surveyor of the Year and Valuation Surveyor of the Year awards. In 2026 I was promoted to Associate.
        </p>
      </div>
    </div>
  );
};

export default Main;
